const collectionId = 'equality';
const milleage = 'Equality';

module.exports = [
  {
    id: 'silver-30',
    label: '<b>30 silver coin</b>',
    value: 30,
    sellPrice: 30,
    state: 2,
    price: '30,00 €',
    collection: collectionId,
    wave: 2,
    launchDate: '2026-03-10',
    specs: [
      { label: 'Edition year', value: milleage },
      { label: 'Metal', value: 'Silver 900‰' },
      { label: 'Weight', value: '16 g' },
      { label: 'Diameter', value: 'Ø 33' },
      { label: 'Copies', value: '75 000' },
    ],
  },
  {
    id: 'silver-100',
    label: '<b>100 silver coin</b>',
    value: 100,
    sellPrice: 100,
    state: 3,
    price: '100,00 €',
    collection: collectionId,
    wave: 1,
    specs: [
      { label: 'Edition year', value: milleage },
      { label: 'Metal', value: 'Silver 900‰' },
      { label: 'Quality', value: 'Uncirculated quality' },
      { label: 'Weight', value: '45 g' },
      { label: 'Diameter', value: 'Ø 47' },
      { label: 'Copies', value: '10 000' },
    ],
  },
  {
    id: 'gold-250',
    label: '<b>250 gold coin</b>',
    value: 250,
    sellPrice: 250,
    state: 1,
    price: '250,00 €',
    collection: collectionId,
    wave: 1,
    specs: [
      { label: 'Edition year', value: milleage },
      { label: 'Metal', value: 'Gold 999‰' },
      { label: 'Quality', value: 'Uncirculated quality' },
      { label: 'Weight', value: '1,75 g' },
      { label: 'Diameter', value: 'Ø 13' },
      { label: 'Copies', value: '15 000' },
    ],
  },
  {
    id: 'gold-1000',
    label: '<b>1 000 gold coin</b>',
    value: 1000,
    sellPrice: 1090,
    state: 3,
    price: '1000,00 €',
    collection: collectionId,
    wave: 2,
    subscription: {
      startDate: '2026-03-10',
      endDate: '2026-04-10',
    },
    specs: [
      { label: 'Edition year', value: milleage },
      { label: 'Metal', value: 'Gold 999‰' },
      { label: 'Quality', value: 'Uncirculated quality' },
      { label: 'Weight', value: '6,5 g' },
      { label: 'Diameter', value: 'Ø 23' },
      { label: 'Copies', value: '6 000' },
    ],
  },
  {
    id: 'gold-2500',
    label: '<b>2 500 gold coin</b>',
    value: 2500,
    sellPrice: 2675,
    state: 0,
    price: '2500,00 €',
    collection: collectionId,
    wave: 3,
    subscription: {
      startDate: '2026-05-05',
      endDate: '2026-06-05',
    },
    specs: [
      { label: 'Edition year', value: milleage },
      { label: 'Metal', value: 'Gold 999‰' },
      { label: 'Quality', value: 'Uncirculated quality' },
      { label: 'Weight', value: '16,25 g' },
      { label: 'Diameter', value: 'Ø 33' },
      { label: 'Copies', value: '2 000' },
    ],
  },
  {
    id: 'gold-5000',
    label: '<b>5 000 gold coin</b>',
    value: 5000,
    sellPrice: 5250,
    state: 0,
    price: '5000,00 €',
    collection: collectionId,
    wave: 4,
    subscription: {
      startDate: '2026-09-08',
      endDate: '2026-10-09',
    },
    specs: [
      // { label: 'Edition year', value: milleage },
      // { label: 'Metal', value: 'Gold 999‰' },
      // { label: 'Quality', value: 'Uncirculated quality' },
      // { label: 'Weight', value: '11,7 g' },
      // { label: 'Diameter', value: 'Ø 29' },
      // { label: 'Copies', value: '6 000' },
    ],
  },
  {
    id: 'gold-10000',
    label: '<b>10 000 gold coin</b>',
    value: 10000,
    sellPrice: 10500,
    state: 0,
    price: '10000,00 €',
    collection: collectionId,
    wave: 5,
    launchDate: '2026-11-10',
    specs: [
      // { label: 'Edition year', value: milleage },
      // { label: 'Metal', value: 'Gold 999‰' },
      // { label: 'Quality', value: 'Uncirculated quality' },
      // { label: 'Weight', value: '11,7 g' },
      // { label: 'Diameter', value: 'Ø 29' },
      // { label: 'Copies', value: '6 000' },
    ],
  },
];
